/**
 * @ Author: yeyu
 * @ Create Time: 2021-06-08 10:23:54
 * @ Modified by: Your name
 * @ Modified time: 2021-06-08 10:27:53
 * @ Description:
 */
export default {
  /**
   * 判断是否是安卓
   */
  isAndroid() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端或者uc浏览器
  },
  /**
   * 判断是否是ios
   */
  isiOS() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  },
  /**
   * 判断是否是鸿蒙
   */
  isHarmony() {
      var u = navigator.userAgent
      return u.indexOf("OpenHarmony") > -1;
  }
};



// WEBPACK FOOTER //
// ./src/utils/until.js